import { deliveryList, remittanceCreateCancel } from '../../services/api';

const PICKUP_LIST = 'pickup/PICKUP_LIST';
const PICKUP_LIST_SUCCESS = 'pickup/PICKUP_LIST_SUCCESS';

export const viewList = data => ({
  type: PICKUP_LIST,
  payload: {
    client: 'secure',
    request: {
      ...deliveryList,
      data,
    },
  },
});

const PICKUP_CANCEL = 'pickup/PICKUP_PACKAGE_CANCEL';

export const rtsCancel = tNumber => ({
  type: PICKUP_CANCEL,
  payload: {
    client: 'secure',
    request: {
      ...remittanceCreateCancel(tNumber),
    },
  },
});

const initialState = {
  tableList: [],
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case PICKUP_LIST_SUCCESS:
      return {
        ...state,
        tableList: action.payload.data.rows,
      };

    default:
      return state;
  }
}

export default reducer;
